import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { Header } from '../Common/Header';
import Request from '../../Models/Request';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class RequestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            user: 0,
            request: [],
            modal: false,
            info: ''
        };
        // var logged_user = JSON.parse(window.localStorage.getItem('info'));
        // this.state.user = logged_user.id;
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Request.getAll(0).then(res => {
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
            }
        })
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    componentDidMount() {
        var x = JSON.parse(window.localStorage.getItem('info'));
        this.setState({ info: x })
    }

    alrt() {
        alert("ログインしてください！");
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 50))
            )
        }
    }

    button() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="">
                    <Link to={"/post-request"}><button type="button" style={{ width: '180px' }} className="agree_button">リクエストを投稿する</button></Link><br /><br />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="">
                    <Link to={"/post-request"}><button type="button" className="agree_button">リクエストを投稿する</button></Link><br /><br />
                </div>
            )
        }
    }

    request() {
        // if (!localStorage.getItem('info')) {
        //     return (
        //         <div>
        //             <Button className="btn btn-success ml-5 mb-3" style={{ width: '150px' }} onClick={this.toggle.bind(this)}>リクエストを投稿する</Button>
        //             <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className={this.props.className}>
        //                 <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
        //                 <ModalBody>
        //                     ログインしてください。
        //                 </ModalBody>
        //                 <ModalFooter>
        //                     <Button color="danger" onClick={this.toggle.bind(this)}>閉じる</Button>
        //                 </ModalFooter>
        //             </Modal>
        //         </div>
        //     )
        // } else {
        return (
            <div>
                <div className="request_text">
                    <br />
                    <br />
                    {this.button()}
                </div>
                <div className="row  px-3">
                    {this.state.request.map(group =>
                        <div className="mini_padding inner-div" style={{ width: "100%" }} key={group.id}>
                            <div className="mini_padding hover_div">
                                <div className="row">
                                    <div className="col-md-2">
                                        <img src={group.img} className="img-responsive rounded-circle" alt="" width="100%" height="80%" />
                                    </div>
                                    <div className="col-md-4" style={{ fontSize: "13px" }}>
                                        {(() => {
                                            if (this.state.info.user_type_id !== 1) {
                                                return (
                                                    <div>
                                                        < Link to={{
                                                            pathname: `/request-details/${group.id}`,
                                                            state: { id: group.id, user: this.state.user }
                                                        }}>
                                                            <span className="sky-a" style={{ cursor: "pointer" }}>{group.title}</span>
                                                        </Link>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div>
                                                        <span className="sky-a">{group.title}</span>
                                                    </div>
                                                )
                                            }
                                        })()}

                                        <div>
                                            <span className="web_text_agency"><b></b></span>
                                        </div>
                                        <div>
                                            {this.details(group.content)}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td className="vline-left"><b>予算 {group.budget_range} Yen</b></td>

                                                    <td className="vline"><b>募集期限</b><br />{(JSON.stringify(group.application_date)).substring(1, 11)}</td>
                                                    <td className="vline-right"><b>提案数</b><br />{group.number_of_proposals}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row" style={{ minHeight: "auto" }}>
                            <div className="col-md-12">
                                <div className="" style={{ height: 'auto', marginBottom: '25px', border: '1px solid #ccc' }}>
                                    <br/>
                                    <br/>
                                    {/* <div className="blank_div"></div> */}
                                    {this.request()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row" style={{ minHeight: "500px" }}>
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8">
                                        <div className="" style={{ height: 'auto', marginBottom: '25px', border: '1px solid #ccc' }}>
                                            {/* <div className="blank_div"></div> */}
                                            <br/>
                                            <br/>
                                            {this.request()}
                                            <div className="col-md-2"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { RequestList }